export enum EnumPartnerTypes {
  CheckIn = "CheckIn",
  Hook = "Hook",
  ProductionData = "ProductionData",
}

export enum EnumConnectProtocols {
  API = "API",
  DB = "DB",
}

export enum EnumAuthTypes {
  // Enum from backend, adding typical ones, or string if unknown
  Basic = "Basic",
  Bearer = "Bearer",
  OAuth2 = "OAuth2",
  OAuth1 = "OAuth1",
  ApiKey = "ApiKey",
  None = "None",
}

export enum EnumMethodRequests {
  Pull = "Pull",
  Push = "Push",
}

export interface IHubPartnerCreateRequest {
  code: string;
  name?: string;
  type: EnumPartnerTypes | string;
  authType: EnumAuthTypes | string;
  methodRequest: EnumMethodRequests | string;
  ips?: string[];
  status: number;
  orgId: number;
}

export interface IHubPartnerUpdateRequest extends IHubPartnerCreateRequest {
  id: string;
}

export interface PartnerDetailResponse {
  id: string;
  code: string;
  name?: string;
  type: string;
  authType: string;
  methodRequest: string;
  ips?: string[];
  status: number;
  orgId: number;
  settings?: PartnerSettingDetailResponse[];
  createdAt?: string;
  updatedAt?: string;
}

export interface PartnerListRequest {
  orgId?: number | string;
  keyword?: string;
  status?: number;
  type?: string;
  page?: number;
  limit?: number;
  [key: string]: unknown;
}

export enum EnumSettingTypes {
  SyncEmployee = "SyncEmployee",
  SyncDepartment = "SyncDepartment",
  SyncTitle = "SyncTitle",
  SyncLocation = "SyncLocation",
  Auth = "Auth",
  TimeAttendance = "TimeAttendance",
  Leave = "Leave",
  OverTime = "OverTime",
  Hook = "Hook",
  MachineDowntime = "MachineDowntime",
  OTTime = "OTTime",
  ProductionLog = "ProductionLog",
}

export enum EnumHookSettingTypes {
  Title = "Title",
  Department = "Department",
  Staff = "Staff",
  Shift = "Shift",
  ShiftStaff = "ShiftStaff",
  ShiftSwapStaff = "ShiftSwapStaff",
  MesShiftEmpOTTask = "MesShiftEmpOTTask",
  MesShiftMachineStop = "MesShiftMachineStop",
  MesShiftMachineRunCount = "MesShiftMachineRunCount",

  ONEOFFICE_GetEmployeeList = "ONEOFFICE_GetEmployeeList",
  ONEOFFICE_GetEmployeeDetail = "ONEOFFICE_GetEmployeeDetail",
  ONEOFFICE_UpdateEmployee = "ONEOFFICE_UpdateEmployee",
}

export enum EnumMethods {
  Get = "Get",
  Post = "Post",
}

export interface IHubPartnerSettingCreateRequest {
  orgId: number;
  status: number;
  type: EnumSettingTypes | EnumHookSettingTypes | string;
  connectProtocol: EnumConnectProtocols | string;
  host?: string;
  method?: EnumMethods | string;
  requestParams?: Record<string, unknown> | unknown;
  requestParamsMapping?: Record<string, unknown> | unknown;
  responseSchema?: Record<string, unknown> | unknown;
  responseDataMapping?: Record<string, unknown> | unknown;
  username?: string;
  password?: string;
  apiKey?: string;
  consumerKey?: string;
  consumerSecret?: string;
  tokenId?: string;
  tokenSecret?: string;
  realm?: string;
  timezone?: string;
  metadata?: Record<string, unknown> | unknown;
}

export interface IHubPartnerSettingUpdateRequest
  extends IHubPartnerSettingCreateRequest {
  id: string;
}

export interface PartnerSettingDetailResponse
  extends IHubPartnerSettingCreateRequest {
  id: string;
  partnerId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PartnerSettingListRequest {
  partnerId: string;
  keyword?: string;
  status?: number;
  type?: string;
  page?: number;
  limit?: number;
  [key: string]: unknown;
}
